import {
    bitbucketOfferingSkusArray,
    bitbucketPlanLimitConfigs
} from "../../../../uniform/components/pricing-calculator/src/configs/bitbucket.pricing-calculator-config.ts";
import {
    compassOfferingSkusArray,
    compassPlanLimitConfigs,
    confluenceOfferingSkusArray,
    confluencePlanLimitConfigs,
    guardOfferingSkusArray,
    guardPlanLimitConfigs,
    jiraOfferingSkusArray,
    jiraPlanLimitConfigs,
    jpdOfferingSkusArray,
    jpdPlanLimitConfigs,
    jsmOfferingSkusArray,
    jsmPlanLimitConfigs,
    loomOfferingSkusArray,
    loomPlanLimitConfigs,
    rovoDevOfferingSkusArray,
    rovoDevPlanLimitConfigs,
    serviceCollectionOfferingSkusArray,
    serviceCollectionPlanLimitConfigs,
    strategyCollectionOfferingSkusArray,
    strategyCollectionPlanLimitConfigs,
    teamworkCollectionOfferingSkusArray,
    teamworkCollectionPlanLimitConfigs
} from "../../../../uniform/components/pricing-calculator/src/configs/index.ts";

import type { PlanLimitConfigs } from "../../../../uniform/components/pricing-calculator/src/index.ts";

export const getOfferingSkusArrayByUrlSlug = (
    urlSlug: string
): string[] | undefined => {
    const urlSlugToSkusArray: Record<string, readonly string[]> = {
        "jira": jiraOfferingSkusArray,
        "confluence": confluenceOfferingSkusArray,
        "bitbucket": bitbucketOfferingSkusArray,
        "loom": loomOfferingSkusArray,
        "compass": compassOfferingSkusArray,
        "guard": guardOfferingSkusArray,
        "rovo-dev": rovoDevOfferingSkusArray,
        "product-discovery": jpdOfferingSkusArray(),
        "service-management": jsmOfferingSkusArray,
        "service": serviceCollectionOfferingSkusArray,
        "strategy": strategyCollectionOfferingSkusArray,
        "teamwork": teamworkCollectionOfferingSkusArray
    };

    return urlSlugToSkusArray[urlSlug] as string[] | undefined;
};

export const getPlanLimitConfigsByUrlSlug = (
    urlSlug: string
): PlanLimitConfigs[] | undefined => {
    const urlSlugToPlanLimitConfigs: Record<string, PlanLimitConfigs[]> = {
        "jira": jiraPlanLimitConfigs,
        "confluence": confluencePlanLimitConfigs,
        "bitbucket": bitbucketPlanLimitConfigs,
        "loom": loomPlanLimitConfigs,
        "compass": compassPlanLimitConfigs,
        "guard": guardPlanLimitConfigs,
        "rovo-dev": rovoDevPlanLimitConfigs,
        "product-discovery": jpdPlanLimitConfigs(),
        "service-management": jsmPlanLimitConfigs,
        "service": serviceCollectionPlanLimitConfigs,
        "strategy": strategyCollectionPlanLimitConfigs,
        "teamwork": teamworkCollectionPlanLimitConfigs
    };

    return urlSlugToPlanLimitConfigs[urlSlug];
};
